import * as Redux from 'redux';
import { ActionMeta } from 'redux-actions';
import { PageParameters } from '../models/account';
import { SimManagementError } from '../models/Errors';
import { QueryResult } from '../models/queryResult';
import {
  CLEAR_USER_ROLES,
  ENSURE_USER_ROLES,
  LOAD_USER_ROLES,
  LOAD_USER_ROLES_FAILURE,
  LOAD_USER_ROLES_SUCCESS,
} from './actionTypes';
import { Action } from './commonActions';

/**
 * An action that clears the user roles
 */
export function clearUserRoles(): Redux.Action {
  return {
    type: CLEAR_USER_ROLES,
  };
}

/**
 * Action which ensures that the selected account is loaded and will fetch from server if it is not.
 * @param value The account details.
 */
export function ensureUserRoles(value: PageParameters): Action<PageParameters> {
  return {
    type: ENSURE_USER_ROLES,
    payload: value,
  };
}

/**
 * Action which loads the user roles from the server.
 * @param account The account details.
 */
export function loadUserRoles(account: PageParameters): Action<PageParameters> {
  return {
    type: LOAD_USER_ROLES,
    payload: account,
  };
}

/**
 * Action which handles when the user roles are successfully loaded.
 * @param meta The meta data.
 * @param queryResult The user roles query result.
 */
export function loadUserRolesSuccess(
  meta: PageParameters,
  queryResult: QueryResult<string>,
): ActionMeta<QueryResult<string>, PageParameters> {
  return {
    type: LOAD_USER_ROLES_SUCCESS,
    payload: queryResult,
    meta,
  };
}

/**
 * Action which handles when there is a failure to load the user roles.
 * @param meta Meta data about the account.
 * @param error The error.
 */
export function loadUserRolesFailure(
  meta: PageParameters,
  error: SimManagementError,
): ActionMeta<SimManagementError, PageParameters> {
  return {
    error: true,
    type: LOAD_USER_ROLES_FAILURE,
    payload: error,
    meta,
  };
}
